export const FIND_MAIL_TEMPLATES_REQUEST = 'FIND_MAIL_TEMPLATES_REQUEST';

export const findMailTemplatesRequest = ({
     filter = [],
     sorting = { field: 'name', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_MAIL_TEMPLATES_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
        pagination,
    }
});
